import React from 'react';
import { makeStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import EventoUsuarioTable from "./EventoUsuarioTable";
import EventoUsuarioForm from "./EventoUsuarioForm";

const useStyles = makeStyles({
    paper: {

        padding: '20px',
        backgroundColor: '#f5f5f5',
    },
    table: {
        paddingTop: '20px;',
        margin: '20px'
    },
    title: {
        marginBottom: '20px'
    },
    cursorLink: {
        cursor: 'pointer'
    }
});

export default function ComunicadoUsuarioContainer() {
    const classes = useStyles();
    const evento = useSelector(state => state.evento);

    return (
        <div>
            <CssBaseline />
            <Container className={classes.paper} component={Paper}>
                <Grid container justify="space-between">
                    <Grid size={3}>
                        <Typography className={classes.title} variant="h5">
                            Eventos
                        </Typography>
                    </Grid>
                    
                </Grid>

                {evento ?
                    <EventoUsuarioForm />
                    : ''}

                {evento && evento.codigo ?
                    ''
                    : <EventoUsuarioTable />}
            </Container>
        </div>
    );
}